import { Component, OnInit } from '@angular/core';
import { ApplicationBase } from 'src/app/base/application-base';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { LoggedUser } from 'src/app/models/auth/logged-user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';

@Component({
  selector: 'app-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends ApplicationBase implements IWindowContent, OnInit {
  private windowId: number;

  activeTab = 0;

  constructor(
    private windowsSv: WindowsManagerService) {
    super();
  }

  ngOnInit(): void {
  }

  start(data: any, windowId: number) {
    this.windowId = windowId;

    this.windowsSv.setTitle(windowId, "Authentication");
  }

  loginSuccess(user: LoggedUser) {
    this.windowsSv.disposeWindow(this.windowId);
  }

  registerSuccess() {
    this.windowsSv.disposeWindow(this.windowId);
  }
}
